"use client";
import { useContext } from "react";

import { AppContext } from "./AppContext";
import { icons } from "./icons";

export default function Scale() {
	const { setScale, scale, refreshGrid } = useContext(AppContext);
	const scales = [1, 0.8, 0.6, 0.2];

	return (
		<div className="divide-color border-color flex select-none items-center divide-x overflow-hidden rounded border dark:bg-dark-800">
			<div
				className="flexer hu wu cursor-pointer hover:bg-dark-100 dark:hover:bg-dark-700"
				onClick={() => {
					const n = scales.indexOf(scale) + 1;
					setScale(scales[n > 3 ? 3 : n]);
					refreshGrid();
				}}
			>
				<div className="scale-75">{icons.minus}</div>
			</div>
			<div className="flexer hu miniLabel w-14">{100 * scale + "%"}</div>
			<div
				className="flexer hu wu cursor-pointer hover:bg-dark-100 dark:hover:bg-dark-700"
				onClick={() => {
					const n = scales.indexOf(scale) - 1;
					setScale(scales[n < 0 ? 0 : n]);

					refreshGrid();
				}}
			>
				<div className="scale-75">{icons.plus}</div>
			</div>
		</div>
	);

	/* return (
		<div className="flex items-center gap-2">
			<div className="miniLabel">100%</div>
			<div className=" flexer h-6 w-[70px]">
				<RangeSlider
					min={0}
					max={3}
					value={cur}
					onInput={(e) => {
						setCur([0, e[1]]);

						refreshGrid();
					}}
					className="scaleSlider"
				/>
			</div>
			<div className="miniLabel">20%</div>
		</div>
	); */
}
